import {
  GET_LAYERS,
  SET_ACTIVE_LAYER,
  SET_BASE_MAP,
  SET_CITRA,
  SET_BIDANG_LAYER,
  SET_DIRECTION_TOGGLE,
  SET_INACTIVE_LAYER,
  SET_LAYER_NOW,
  SET_MARKERS,
  SET_SIDEBAR_TOGGLE,
  SET_LEGEND_NOW,
  SET_ALL_BIDANG,
  SET_URL_FILTER,
  SET_SPESIFICT_HIERARKI,
  SET_ACTIVE_LIST,
  SET_LAYERS_FROM_MAPS,
  SET_UPDATE_LAYERS_FROM_MAPS,
  SET_HOLLOW_MAPS,
  SET_BIDANG_RESULT,
  SET_GEOJSON_EDITING_DATA,
  SET_STYLES_VALUES,
  FILTER_LEGEND_MAP,
  LOADING_RENDER_MAP,
  SET_LEGENDA_ARR,
  RESET_BIDANG_HIERARKI,
  SET_SIG_TIPE_DATA,
  SET_SHOW_PETA_JALAN,
  SET_URL_FILTER_BY_FIELD,
  SET_TRIGGER_REQUEST,
} from "./constants";

export const setActiveLayers = (layer) => ({
  type: SET_ACTIVE_LAYER,
  payload: layer,
});

export const setInactiveLayers = (layer) => ({
  type: SET_INACTIVE_LAYER,
  payload: layer,
});

export const setBaseMap = (basemap) => ({
  type: SET_BASE_MAP,
  payload: basemap,
});

export const setLayerNow = (layernow) => ({
  type: SET_LAYER_NOW,
  payload: layernow,
});

export const setDirectionToggle = (toggle) => ({
  type: SET_DIRECTION_TOGGLE,
  payload: toggle,
});

export const setMarkers = (markers) => ({
  type: SET_MARKERS,
  payload: markers,
});

export const getLayers = (layers) => ({
  type: GET_LAYERS,
  payload: layers,
});

export const setCitra = (citra) => ({
  type: SET_CITRA,
  payload: citra,
});

export const setSidebarToggle = (toggle) => ({
  type: SET_SIDEBAR_TOGGLE,
  payload: toggle,
});

export const setBidangLayer = (bidangLayer) => ({
  type: SET_BIDANG_LAYER,
  payload: bidangLayer,
});

export const setLegendNow = (legendNow) => ({
  type: SET_LEGEND_NOW,
  payload: legendNow,
});

export const setAllBidang = (allBidang) => ({
  type: SET_ALL_BIDANG,
  payload: allBidang,
});

export const setURLFilter = (urlFilter) => ({
  type: SET_URL_FILTER,
  payload: urlFilter,
});

export const setSpecifictHierarki = (specifictHierarki) => ({
  type: SET_SPESIFICT_HIERARKI,
  payload: specifictHierarki,
});

export const setActiveList = (activeList) => ({
  type: SET_ACTIVE_LIST,
  payload: activeList,
});

export const setLayersFromMaps = (layerFromMaps) => ({
  type: SET_LAYERS_FROM_MAPS,
  payload: layerFromMaps,
});

export const setUpdateLayersFromMaps = (currentList, layerNew) => ({
  type: SET_UPDATE_LAYERS_FROM_MAPS,
  payload: { currentList, layerNew },
});

export const setHollowMaps = (hollowMaps) => ({
  type: SET_HOLLOW_MAPS,
  payload: hollowMaps,
});

export const setBidangResult = (bidangResult) => ({
  type: SET_BIDANG_RESULT,
  payload: bidangResult,
});

export const setGeoJSONEditingData = (geoJSON) => ({
  type: SET_GEOJSON_EDITING_DATA,
  payload: geoJSON,
});

export const loadingRenderMap = (loading) => ({
  type: LOADING_RENDER_MAP,
  payload: loading,
});

export const setStylesValue = (stylesValue) => ({
  type: SET_STYLES_VALUES,
  payload: stylesValue,
});

export const filterLegendMap = (legendMap) => ({
  type: FILTER_LEGEND_MAP,
  payload: legendMap,
});

export const setLegendaArr = (legendaArr) => ({
  type: SET_LEGENDA_ARR,
  payload: legendaArr,
});

export const resetBidangHierarki = (bidangHierarki) => ({
  type: RESET_BIDANG_HIERARKI,
  payload: bidangHierarki,
});

export const setSigTipeData = (sigTipeData) => ({
  type: SET_SIG_TIPE_DATA,
  payload: sigTipeData,
});

export const setShowPetaJalan = (showPetaJalan) => ({
  type: SET_SHOW_PETA_JALAN,
  payload: showPetaJalan,
});

export const setURLFilterByField = (urlFilterByField) => ({
  type: SET_URL_FILTER_BY_FIELD,
  payload: urlFilterByField,
});

export const setTriggerRequest = (triggerRequest) => ({
  type: SET_TRIGGER_REQUEST,
  payload: triggerRequest,
});
